// import { strMark } from '@/utils/util'
import { FILEURL, FILETYPE } from '../../config/constant.js'
import chat from '../../components/chat'
// import Department from '../../components/department'
import selectDepPers from './components/selectDepPers/selectDepPers.vue'
// import Section from './components/section'
let _self
export const index = {
  components: {
    chat,
    selectDepPers
  },
  data() {
    this.timeCode = new Date().getTime()
    return {
      searchContent: '',
      radio: 1,
      radio2: 1,
      intervalId: '',
      ablie: false,
      isable: false,
      showEmpty: true,
      showTotal: false,
      isCompute: false,
      FILEURL,
      FILETYPE,
      pickerMinDate: '',
      pickerOptions0: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime()
          // alert(this.pickerMinDate)
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 30 * 24 * 3600 * 1000
            const maxTime = this.pickerMinDate + day1
            const minTime = this.pickerMinDate - day1
            // console.log(this.pickerMinDate)
            // alert(time.getTime())
            // return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()
            // return time.getTime() > maxTime || time.getTime() < minTime
          } else {
            return time.getTime() > Date.now() + 0 * 24 * 3600 * 1000
          }
        }
        // disabledDate(time) {
        //   return time.getTime() > new Date(new Date().toLocaleDateString()).getTime()
        // }
      },
      leaveAllList: [],
      tabs: [
        {
          title: '在职员工存档',
          auth: 'auditOn'
        },
        {
          title: '离职员工存档',
          auth: 'auditOff'
        }
      ],
      treeData: [],
      isDepartment: false,
      checkedDimission: [],
      filterText: '',
      defaultProps: {
        children: 'child',
        label: 'checkTitle',
        id: 'id'
      },
      redpacketType: ['', '普通红包', '拼手气群红包', '激励群红包'],
      tabIndex: 0,
      searchForm: {
        content: '',
        sendName: '',
        sendOutName: '',
        receiverName: '',
        staffNamea: '',
        staffName: '',
        recName: '',
        scopeDate: '',
        takeOutName: '',
        record_type: 'all'
      },
      activeNames: [],
      count: '',
      id: [],
      type: '',
      listData: [],
      searchData: { total: 0, data: [], arr: [] },
      receiverList: [],
      msgId: '',
      total: 0,
      dialogVisible: false,
      maskText: '',
      loading: false,
      loading01: false,
      record_typeOptions: [],
      isDepartmentDialog: false,
      ialog: false,
      isSearchContent: false,
      set_page: 1,
      page: 1,
      isRandomMsg: true,
      isMoreBtn: true,
      isSearchBtn: true,
      isSearchBtnDisabled: true,
      isSearchBtnDisabled1: true,
      leaveList: [],
      isdisabled: false,
      freceiverList: [],
      random_str: '',
      contents: '',
      coush: '',
      nihf: false,
      busy: true,
      checkedEmployees: [],
      checkedDepartments: [],
      showjv: [],
      checkedStafftDep: [],
      clientWidth: '',
      checkIndexs: [],
      curDataNum: 0,
      searchPost: {},
      listFlag: 0,
      msgDay: '',
      searchError: false,
      selectData: []
    }
  },
  beforeMount() {
    const authList = this.$store.state.authList
    if (authList.includes('auditOff') && !authList.includes('auditOn')) {
      this.tabIndex = 1
    }
  },
  mounted() {
    _self = this
    // this.getEandomMsg()
    this.selectChange()
   // this.getLeaveStaff()
   if (this.intervalId) clearInterval(this.intervalId)
   this.clientWidth = document.body.clientWidth
  },
  destroyed() {
     if (this.intervalId) clearInterval(this.intervalId)
  },
  watch: {
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.sfhusi()
      }
    },
    'searchForm.scopeDate': function(val) {
      if (!val) {
        this.pickerMinDate = ''
      }
    }
  },
  methods: {
  //  strMark,
    getFileType(content) {
      // if (typeof content === 'string') {
      //   const file = JSON.parse(content).filename.split('.')
      //   return file[file.length - 1]
      //   // const file = content.filename.split('.')
      //   // return file[file.length - 1]
      // }
      const file = content.split('.')
      return file[file.length - 1]
    },
    strMark(str, mark) {
      // alert(str)
      if (mark === undefined) {
      } else {
        let titleString = str
        const replaceReg = new RegExp(mark, 'g' )
        const replaceString = '<span style="background: #FAFF85FF;">' + mark + '</span>'
        titleString = titleString.replace(replaceReg, replaceString)
        // 汪勇
        // var regMark = mark.replace(/\[|\]|\(|\)|\*|\+|\?|\$|\\/g, '\\$&')
        // let titleString = str.replace(/[\n\r]+/g, '')
        // const replaceReg = new RegExp(regMark, 'gi' )
        // const replaceString = '<span style="background: #FAFF85FF;">' + mark + '</span>'
        // titleString = titleString.replace(replaceReg, replaceString)
        return titleString
        // let chars = []
        // var y = str.toLowerCase()
        // chars = mark.split(',')
        // chars.forEach(k => {
        //   y = y.replace(k, '<span style="background: #FAFF85FF;">' + k + '</span>')
        // })
        // return y
      }
    },
    onSearch(searchForm) {
      this.msgId = ''
      this.searchData.data = []
      this.listData = []
      this.activeNames = []
      this.isdisabled = true
      this.checkIndexs = []
      this.listFlag = 0
      this.selectData = []
      this.searchError = false
      this.searchContent = this.searchForm.content
      if (this.tabIndex === 1) {
        if (searchForm.staffNamea === '') {
          this.$message({
            message: '请输入发送人！',
            type: 'warning'
          })
          this.isdisabled = false
          this.total = 0
          return false
        }
      }
      if (Object.values(searchForm).filter(v => v !== '' && v !== null).length < 2) {
        this.$message({
          message: '除消息类型外，请选择至少一个选项查询',
          type: 'warning'
        })
        this.isdisabled = false
        this.total = 0
        return false
      }
      if (!searchForm.scopeDate) {
        this.$message({
          message: '请选择时间缩短查询范围！',
          type: 'warning'
        })
        this.total = 0
        this.isdisabled = false
        return false
      }
      // if (searchForm.sendName === '' && searchForm.receiverName === '' && searchForm.staffNamea === '' && searchForm.recName === '') {
      //   if (this.searchForm.content !== '' && !searchForm.scopeDate) {
      //     this.$message({
      //       message: '请选择时间缩短查询范围！',
      //       type: 'warning'
      //     })
      //     this.total = 0
      //     this.isdisabled = false
      //     return false
      //   }
      // }

      var contentCheck = true
      // if (/^\w+(\.\w+)?$/.test(this.searchForm.content)) {
      //   if (this.searchForm.content && this.searchForm.content !== '' && this.searchForm.content.length < 2) contentCheck = false
      // } else {
      //   if (this.searchForm.content && this.searchForm.content !== '' && this.searchForm.content.length < 2) contentCheck = false
      // }

      if (this.searchForm.content && this.searchForm.content !== '' && this.searchForm.content.length < 2) contentCheck = false

      if (!contentCheck) {
        this.$message({
          message: '关键词需要设置两个字及以上才能被查询',
          type: 'warning'
        })
        this.total = 0
        this.searchError = true
        this.isdisabled = false
        return false
      }

      this.searchData = { total: 0, data: [] }
      this.showEmpty = true
       this.showTotal = false
      if (this.tabIndex === 0) {
        this.set_page = 1
        this.handleSearch()
        this.getCount()
      } else {
        if (this.searchForm.staffNamea === '') {
          this.$message({
            message: '请选择时间离职员工！',
            type: 'warning'
          })
          return false
        } else {
          this.set_page = 1
          this.handleSearch()
          this.getCount()
        }
      }
      this.isSearchBtnDisabled = false
    },

    handleScroll() {
      if (this.curDataNum < 10 && this.listFlag === 0) {
          this.listFlag = this.set_page
      }
      if (!this.isdisabled && !this.searchError) {
        this.handleSearch(1)
      }
    },
    setSearchPost() {
        let scopeTime = {}
        const { content, record_type, sendDepIds, departDepIds, receiverName, recName, sendOutName, scopeDate } = this.searchForm
        if (scopeDate && scopeDate.length) {
          scopeTime = {
            start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
            end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
        }
        let sendOutNames = sendOutName
        let receiverNames = receiverName
        if (this.tabIndex === 1) {
          sendOutNames = receiverName
          receiverNames = ''
        }
        this.searchPost = {
          staff_user_id: sendOutNames || receiverNames || this.searchForm.staffNamea, // 发送员工 ==>发送者id
          customer_user_id: recName || this.searchForm.takeOutName, // 客户 ===>jieshouhz==fsdi

          record_type: record_type,
          key_word: content,
          start_time: scopeTime.start_time,
          end_time: scopeTime.end_time,
          send_dep_ids: sendDepIds,
          depart_dep_ids: departDepIds
        }
    },

    handleSearch(val) {
      if (!val) this.setSearchPost()
      this.searchPost.page = this.set_page
      this.searchPost.list_flag = this.listFlag
      this.isdisabled = true
      this.set_page = this.set_page + 1
      this.$api
        .get('/api/system/search/content/audit', this.searchPost )
        .then(
          res => {
            if (res.is_busy) {
              // this.isCompute = true
              // setTimeout( function() { _self.handleSearch() }, 5000)
            }
            if (res.data) _self.curDataNum = res.data.length
            if (res.is_update === 0) {
              if (res.data.length === 0) {
                // this.$message.info('没有更多数据了！')
                this.busy = true
              } else {
                const keys = Object.keys(res.data)
                if (keys.length > 0) {
                  const data = this.searchData.data
                  keys.forEach((v, n) => {
                    data.push(res.data[v])
                  })
                  this.searchData = {
                    data
                  }
                  this.isdisabled = false
                  // if (keys.length === 10) {
                  //   this.busy = false
                  // }

                  this.busy = false
                }
                this.isMoreBtn = false
              }
            } else {
              const keys = Object.keys(res.data)
              if (keys.length > 0) {
                // const data = []
                const data = this.searchData.data

                keys.forEach((v, n) => {
                  data.push(res.data[v])
                })
                this.searchData = {
                //  total: res.total,
                  data
                }
                this.isdisabled = false
                // this.busy = false

                this.busy = false
                this.eqweqw()
              } else {
                this.busy = true
              }
            }
            if (this.searchData.data.length === 0 ) {
              this.showEmpty = true
            } else {
              this.showEmpty = false
            }
            this.isdisabled = false
          },
          () => {
            this.isSearchBtnDisabled = true
            // this.$message.error('请求超时,请稍后重试！')
            // setTimeout( function() { _self.handleSearch() }, 5000)
             this.isdisabled = false
          })
    },
    eqweqw() {
      let scopeTime = {}
      const { content, record_type, sendDepIds, departDepIds, receiverName, recName, sendOutName, scopeDate } = this.searchForm
      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
      }
      }
      let sendOutNames = sendOutName
      let receiverNames = receiverName
      if (this.tabIndex === 1) {
        sendOutNames = receiverName
        receiverNames = ''
      }
      this.isdisabled = true
      this.$api
        .get('/api/system/search/content/audit', {
          staff_user_id: sendOutNames || receiverNames || this.searchForm.staffNamea, // 发送员工 ==>发送者id
          customer_user_id: recName || this.searchForm.takeOutName, // 客户 ===>jieshouhz==fsdi
          page: this.set_page,
          record_type: record_type,
          key_word: content,
          start_time: scopeTime.start_time,
          end_time: scopeTime.end_time,
          send_dep_ids: sendDepIds,
          depart_dep_ids: departDepIds
        })
        .then(
          res => {
            if (res.is_update === 0) {
              if (res.data === 0) {
                // this.$message.info('没有更多数据了！')
                this.busy = true
                // this.$message.info('没有相关的消息记录！')
              } else {
                const keys = Object.keys(res.data)
                if (keys.length > 0) {
                  const data = []
                  keys.forEach((v, n) => {
                    data.push(res.data[v])
                  })
                  this.searchData.data = this.searchData.data.concat(data)
                  this.isdisabled = false
                  this.set_page = this.set_page + 1
                  this.busy = false
                } else {
                  this.isdisabled = false
                  this.busy = true
                }
                this.isMoreBtn = false
              }
            } else {
              const keys = Object.keys(res.data)
                if (keys.length > 0) {
                  const data = []
                  keys.forEach((v, n) => {
                    data.push(res.data[v])
                  })
                  this.searchData.data = this.searchData.data.concat(data)
                  this.isdisabled = false
                  // this.busy = false
                  this.set_page = this.set_page + 1
                } else {
                  this.isdisabled = false
                  // this.$message.info('没有更多数据了！')
                  this.busy = true
                }
                this.isMoreBtn = false
            }
            this.isdisabled = false
          },
          () => {
            this.isdisabled = false
        })
    },
    getCount() {
      // if (this.intervalId) clearInterval(this.intervalId)
      // _self.getCountData()
      // this.intervalId = setInterval( function () {
      //   _self.getCountData()
      // }, 5000)
      _self.getCountData()
    },
    // 获取查 询条数
    getCountData() {
      this.isCompute = true
      let scopeTime = {}
      const { content, record_type, sendDepIds, departDepIds, receiverName, recName, sendOutName, scopeDate } = this.searchForm

      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
      }
      let sendOutNames = sendOutName
      let receiverNames = receiverName
      if (this.tabIndex === 1) {
        sendOutNames = receiverName
        receiverNames = ''
      }
      // this.isdisabled = true
      // this.isdisabled = false
      this.$api
        .get('api/system/search/content/audit/count', {
          staff_user_id: sendOutNames || receiverNames || this.searchForm.staffNamea, // 发送员工 ==>发送者id
          customer_user_id: recName || this.searchForm.takeOutName, // 客户 ===>jieshouhz==fsdi
          page: this.page,
          record_type: record_type,
          key_word: content,
          start_time: scopeTime.start_time,
          end_time: scopeTime.end_time,
          send_dep_ids: sendDepIds,
          depart_dep_ids: departDepIds
        })
        .then(
          res => {
            if (res.is_busy) {
               this.isCompute = true
              // setTimeout( function() { _self.getCountData() }, 5000)
            } else {
              if (this.intervalId) clearInterval(this.intervalId)
              this.isCompute = false
            }
            this.total = res.count
            // this.isdisabled = false
          }, () => {
            // setTimeout( function() { _self.getCountData() }, 5000)
        })
    },
    getEand() {
      this.page = this.page + 1
      this.getEandomMsg()
    },
    // 获取随机数据
    getEandomMsg() {
      this.msgId = ''
      this.$api
        .get('/api/system/search/random/data', {
          random_str: this.random_str,
          page: this.page
        //  cursor: this.timeCode
        })
        .then(res => {
          this.random_str = res.random_str
          if (res.data) {
            this.msgId = res.data[0].msg_id
          } else {
            this.isRandomMsg = false
          }
        })
    },
    receiverRemote(query) {
      if (query !== '') {
        this.loading = true
        this.receiverList = this.getUser(2, query)
        setTimeout(() => {
          this.loading = false
        }, 200)
      } else {
        this.receiverList = []
      }
    },
    receiver(query) {
      if (query !== '') {
        this.loading = true
        this.receiverList = this.getUser(2, query)
        setTimeout(() => {
          this.loading = false
        }, 200)
      } else {
        this.receiverList = []
      }
    },
    receiverStaff(query) {
      if (query !== '') {
        this.loading = true
        this.receiverList = this.getLeaveStaff(query)
        setTimeout(() => {
          this.loading = false
        }, 200)
      } else {
        this.receiverList = []
      }
    },
    getchat(user_id, type, count_number, index, msg_day) {
      if ( this.selectData[index] && this.selectData[index].length > 0 ) {
        this.listData = this.selectData[index]
        return false
      }

      if (count_number > 500) {
        this.coush = 500
        // this.coush = 50
      } else {
        this.coush = count_number
        // this.coush = 50
      }
      let user_data_id = ''
      user_data_id = user_id
      this.type = type
      this.listData = []
      // let scopeTime = {}
      // const { key_word, record_type, sendDepIds, departDepIds, receiverName, recName, sendOutName, start_time, end_time } = this.searchPost
      // let sendOutNames = sendOutName
      // let receiverNames = receiverName
      // if (this.tabIndex === 1) {
      //   sendOutNames = receiverName
      //   receiverNames = ''
      // }
      // if (scopeDate && scopeDate.length) {
      //   scopeTime = {
      //     start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
      //     end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
      //   }
      // }
      var postData = Object.assign({}, this.searchPost)
      postData.user_data_id = user_data_id
      postData.type = this.type
      postData.page = this.page
      postData.msg_day = msg_day
      postData.limit = this.coush
      this.isdisabled = true
      this.$api
        .post('/api/system/search/content/audit/data', postData)
        .then(
          res => {
            if (res.length === 0) {
              this.$message.warning('该聊天记录暂无数据')
            }
            res.forEach(async k => {
              if (k.msg_type === 'image' || k.msg_type === 'emotion') {
                if (typeof k.content === 'string') {
                  k.content = JSON.parse(k.content)
                  if (!k.content.url_path || k.content.url_path === '') {
                    if (!k.content.web_url || k.content.web_url === '') {
                      if (!k.content.file_url || k.content.file_url === '') {
                        } else {
                          k.content.file_url = FILEURL + k.content.file_url
                        }
                    } else {
                        if (k.content.web_url.indexOf('http') !== -1) {
                        } else {
                          k.content.web_url = 'http://' + k.content.web_url
                        }
                      }
                    }
                  } else {
                }
              }
              if (k.msg_type === 'chatrecord') {
              }
            })
            _self.selectData[index] = res
            this.listData = res
            this.isdisabled = false
          })
    },
    ExportRecord1(searchForm) {
      this.isSearchBtnDisabled = true
      setTimeout(() => {
        this.isSearchBtnDisabled = false
      }, 3000)
      // alert( new Date(scopeDate[0]))
      console.log('ssssssssssss')
      let scopeTime = {}
      const { content, record_type, receiverName, recName, sendOutName, scopeDate } = this.searchForm
      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
      }
      let sendOutNames = sendOutName
      let receiverNames = receiverName
      if (this.tabIndex === 1) {
        sendOutNames = receiverName
        receiverNames = ''
      }
      // this.isdisabled = true
      this.$api
        .get('/api/system/v1/export/task/create1', {
          staff_user_id: sendOutNames || receiverNames || this.searchForm.staffNamea, // 发送员工 ==>发送者id
          customer_user_id: recName || this.searchForm.takeOutName, // 客户 ===>jieshouhz==fsdi
          page: this.set_page,
          record_type: record_type,
          key_word: content,
          start_time: scopeTime.start_time,
          end_time: scopeTime.end_time
        })
        .then(res => {
          console.log(res)
          // if (res.ret === 200) {
          //   alert(res.code)
            this.$message({
              message: '导出的文件请到菜单栏中的【下载中心】去下载',
              type: 'success'
            })
          // } else {
          //   alert(res.msg)
          //   this.$message({
          //     message: res.msg,
          //     type: 'warning'
          //   })
          // }
        })
    },
    ExportRecord2(searchForm) {
      this.isSearchBtnDisabled1 = true
      setTimeout(() => {
        this.isSearchBtnDisabled1 = false
      }, 3000)
      // alert(this.msgId)
      console.log('ssssssssssss')
      let scopeTime = {}
      const { content, record_type, receiverName, recName, sendOutName, scopeDate } = this.searchForm

      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
      }
      let sendOutNames = sendOutName
      let receiverNames = receiverName
      if (this.tabIndex === 1) {
        sendOutNames = receiverName
        receiverNames = ''
      }
      // this.isdisabled = true
      this.$api
        .get('/api/system/v1/export/task/create2', {
          staff_user_id: sendOutNames || receiverNames || this.searchForm.staffNamea, // 发送员工 ==>发送者id
          customer_user_id: recName || this.searchForm.takeOutName, // 客户 ===>jieshouhz==fsdi
          page: this.set_page,
          msg_id: this.msgId,
          record_type: record_type,
          key_word: content,
          start_time: scopeTime.start_time,
          end_time: scopeTime.end_time
        })
        .then(res => {
          console.log(res)
          // if (res.ret === 200) {
          //   alert(res.msg)
          this.$message({
            message: '导出的文件请到菜单栏中的【下载中心】去下载',
            type: 'success'
          })
          // } else {
          //   alert(res.msg)
          //   this.$message({
          //     message: res.msg,
          //     type: 'warning'
          //   })
          // }
        })
    },
    chooseDialog(msgId, content, msg_type, action, msgDay) {
      // alert(msgId)
      this.isSearchBtnDisabled1 = false
      // this.isSearchBtnDisabled = false
      this.msgId = ''
      this.maskText = ''
      this.msgDay = msgDay
      setTimeout(() => {
        // if (this.searchForm.record_type === 'revoke') {
        //   this.msgId = content
        // } else {
        //   this.msgId = msgId
        // }
        if (msg_type === 'revoke' || action === 'recall') {
          this.msgId = content
        } else {
          this.msgId = msgId
        }
      }, 200)
    },
    // 获取客户列表
    getUser(type, name) {
      const list = []
      this.$api
        .get('/api/system/user/customer', {
          name,
          page: this.page,
          limit: 100
        })
        .then(res => {
          res.forEach(v => {
            list.push({
              name: v.name,
              value: v.user_id,
              type: v.type,
              corp_name: v.corp_name,
              avatar: v.avatar
            })
          })
          this.freceiverList = list
        })
    },
    // 搜索切换
    changeTab(index) {
      this.$refs.searchForm.resetFields()
      this.tabIndex = index
      this.isSearchContent = false
      this.searchData = {}
      this.total = 0
      // this.msgId = ''
      this.searchForm = {
        record_type: 'all'
      }
      this.searchForm.staffNamea = ''
      this.isSearchBtnDisabled = true
      this.isSearchBtnDisabled1 = true
    },
    // 清除搜索员工
    sendNameClear() {
      this.page = 1
      this.activeNames = []
      this.set_page = 1
      this.searchForm.sendName = ''
      this.searchForm.sendOutName = ''
      this.checkedEmployees = []
      this.checkedDepartments = []
      this.searchForm.sendDepIds = []
      this.searchForm.sendDeps = []
      this.searchForm.sendPers = []
    },
    sendClear() {
      this.page = 1
      this.set_page = 1
      this.checkedDimission = []
      this.searchForm.receiverName = ''
      this.searchForm.staffNamea = ''
    },
    gdsuifhu(item) {
      this.searchForm.staffNamea = item
      this.$forceUpdate()
    },
    shouClear() {
      this.page = 1
      this.set_page = 1
      this.searchForm.staffName = ''
      this.searchForm.takeOutName = ''
      this.showjv = []
      this.checkedStafftDep = []
      this.searchForm.departDepIds = []
      this.searchForm.departDeps = []
      this.searchForm.departPers = []
    },
    openDepartement() {
      this.isDepartmentDialog = true
    },
    openDepart() {
       this.isDepartment = true
    },
    // 选择员工
    checkUser(checkedEmployee) {
      this.checkedEmployees = checkedEmployee
      if (checkedEmployee === '') {
        this.isDepartmentDialog = false
        return false
      }
      this.searchForm.sendPers = checkedEmployee
      var nameList = []
      var persList = []
      var depsList = []
      var selectList = this.searchForm.sendPers.concat(this.searchForm.sendDeps)
      console.log(selectList)
      selectList.forEach((item, i) => { if ( item ) { nameList.push(item.name) } })
      this.searchForm.sendPers.forEach((item, i) => { persList.push(item.id) })
      this.searchForm.sendName = nameList.join(',')
      this.searchForm.sendOutName = persList.join(',')
      this.isDepartmentDialog = false
    },
    // 选择部门
    checkDep(checkedDepartment) {
      this.searchForm.sendDepIds = []
      this.checkedDepartments = checkedDepartment
      if (checkedDepartment === '') {
        this.isDepartmentDialog = false
        return false
      }
      this.searchForm.sendDeps = checkedDepartment
      var nameList = []
      var persList = []
      var depsList = []
      if (!this.searchForm.sendPers) this.searchForm.sendPers = []
      var selectList = this.searchForm.sendPers.concat(this.searchForm.sendDeps)
      selectList.forEach((item, i) => { if ( item ) { nameList.push(item.name) } })
      this.searchForm.sendDeps.forEach((item, i) => { depsList.push(item.id) })
      this.searchForm.sendName = nameList.join(',')
      this.searchForm.sendDepIds = depsList.join(',')
      this.isDepartmentDialog = false
    },
    getDepart(checkedEmployee) {
      this.showjv = checkedEmployee
      if (checkedEmployee === '') {
        this.isDepartment = false
        return false
      }
      this.searchForm.departPers = checkedEmployee
      var nameList = []
      var persList = []
      var depsList = []
      var selectList = this.searchForm.departPers.concat(this.searchForm.departDeps)
      selectList.forEach((item, i) => { if ( item ) { nameList.push(item.name) } })
      this.searchForm.departPers.forEach((item, i) => { persList.push(item.id) })
      this.searchForm.staffName = nameList.join(',')
      this.searchForm.takeOutName = persList.join(',')
      this.isDepartment = false
    },

    getStafftDep(checkedEmployee) {
      this.searchForm.departDepIds = []
      this.checkedStafftDep = checkedEmployee
      if (checkedEmployee === '') {
        this.isDepartment = false
        return false
      }
      this.searchForm.departDeps = checkedEmployee
      var nameList = []
      var persList = []
      var depsList = []
      if (!this.searchForm.departPers) this.searchForm.departPers = []
      var selectList = this.searchForm.departPers.concat(this.searchForm.departDeps)
      selectList.forEach((item, i) => { if ( item ) { nameList.push(item.name) } })
      this.searchForm.departDeps.forEach((item, i) => { depsList.push(item.id) })
      this.searchForm.staffName = nameList.join(',')
      this.searchForm.departDepIds = depsList.join(',')
      this.isDepartment = false
    },

    // 获取离职员工
    getLeaveStaff(name) {
      this.loading01 = true
      this.$api
        .get('/api/system/get/quit/staff', {
          name: name
        })
        .then(res => {
          const list = []
          res.forEach(v => {
            list.push({
              name: v.name + '~' + v.department_name
            })
          })
          this.leaveAllList = res
          this.loading01 = false
        })
    },
    getChecked(value, isCheck) {
      const checkedDimission = this.checkedDimission
      if (isCheck) {
         checkedDimission.push({
          id: value.value,
          name: value.checkTitle
        })
      } else {
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
      }
      this.checkedDimission = [value]
    },
     // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.checkTitle.indexOf(value) !== -1
    },
    qing() {
      // this.page = 1
      // this.set_page = 1
      // this.activeNames = []
    },
    kongkong() {
      this.freceiverList = []
    },
    closeDate() {
      this.$refs.date.handleClose()
    },
    kong(v) {
       this.activeNames = []
       this.page = 1
       this.set_page = 1
    },
    kong02() {
      // this.searchData.data = []
      // this.total = ''
      // this.activeNames = []
      // this.page = 1
      // this.set_page = 1
    },
    kong01(k) {
      this.searchForm.receiverName = k
      this.page = 1
      this.set_page = 1
    },
    selectChange() {
      // this.page = 1
      // this.set_page = 1
      // this.busy = true
      // this.activeNames = []
      // this.searchData.data = []
      this.$api
        .get('/api/system/setting/message/type')
        .then(res => {
          this.record_typeOptions = res
          const options = this.record_typeOptions.filter(v => {
            return v.value === this.searchForm.record_type
          })
          if (options[0].is_text === false) {
            this.isSearchContent = true
            this.searchForm.content = ''
          } else {
            this.isSearchContent = false
          }
        })
    },
    opuj() {
      this.$router.push({ path: '/audit/explain' })
    },
    uroqwi() {
      if (this.radio2 === 2) {
        this.isable = true
      } else {
        this.isable = false
      }
    },
    reset() {
      this.$confirm('重置后，将清除发送人和接收人所填内容', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(() => {
        this.searchForm.sendName = ''
        this.searchForm.sendOutName = ''
        this.searchForm.receiverName = ''
        this.searchForm.recName = ''
        this.searchForm.staffName = ''
        this.searchForm.takeOutName = ''
        this.page = 1
        this.radio = 1
        this.radio2 = 1
        this.set_page = 1
        this.ablie = false
        this.isable = false
        this.checkedEmployees = []
        this.showjv = []
      }).catch(() => {
      })
    },
    async getFile(md5sum) {
      const file = await this.$api.get('/v1/get/file', {
        md5sum: md5sum
      })
      return file
    },
    wqweq() {
      if (this.radio === 2) {
        this.ablie = true
      } else {
        this.ablie = false
      }
    },
    qwedw() {
      if (this.searchForm.receiverName === '') {
      } else {
        this.$confirm('是否确认发送人选择员工进行查询？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.searchForm.receiverName = ''
          this.radio2 = 1
        }).catch(() => {
          this.radio2 = 2
          this.isable = true
        })
      }
    },
    huihwi() {
      if (this.searchForm.sendName === '') {
      } else {
        this.$confirm('是否确认发送人选择客户进行查询？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.radio2 = 2
          this.searchForm.sendName = ''
          this.searchForm.sendOutName = ''
          this.checkedEmployees = []
        }).catch(() => {
          this.radio2 = 1
          this.isable = false
        })
      }
    },
    yiou() {
      if (this.searchForm.recName === '') {
      } else {
        this.$confirm('是否确认接收人选择员工进行查询？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.radio = 1
          this.searchForm.recName = ''
        }).catch(() => {
          this.radio = 2
          this.ablie = true
        })
      }
    },
    ipojin() {
       if (this.searchForm.staffName === '') {
      } else {
        this.$confirm('是否确认接收人选择客户进行查询？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.radio = 2
          this.searchForm.staffName = ''
          this.searchForm.takeOutName = ''
          this.showjv = []
        }).catch(() => {
          this.radio = 1
          this.ablie = false
        })
      }
    },
    getTotal() {
      this.showTotal = true
    }
  }
}
